import { QuestionScore } from '~teacher/models/activities';
import { QuizQuestion } from '~teacher/models/quizzes';

import { effectiveQuestionWeight } from './calculateQuestionWeight';

export const defaultCorrect = (
  question: QuizQuestion,
  questionScore: QuestionScore
) => effectiveQuestionWeight({ question, questionScore });

export const defaultUngraded = (
  question: QuizQuestion,
  questionScore: QuestionScore
) => questionScore?.ungradedScore ?? 0;
